<template>
  <v-container fluid class="px-5">
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>
    <!-- SNACKBAR -->

    <!-- GUARDAR / EDITAR -->
    <v-dialog v-model="dialog" width="400" persistent>
      <v-form ref="form" lazy-validation>
        <v-card>
          <v-card-title>{{ getDialogTitle }}</v-card-title>
          <v-card-text class="pb-0">
            <v-row>
              <v-col cols="12" class="pt-0">
                <v-autocomplete
                  class="pt-0"
                  v-model="servicio.tipoAsistenciaId"
                  :items="tipoAsistencias"
                  :rules="requiredRule"
                  item-text="nombre"
                  item-value="id_tipo_asistencia"
                  label="Tipo Asistencia"
                  clearable
                >
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                class="pt-0"
                v-if="
                  servicio.tipoAsistenciaId == AJUSTE ||
                  servicio.tipoAsistenciaId == AUXILIO_VIAL
                "
              >
                <v-autocomplete
                  class="pt-0"
                  v-model="servicio.localidadId"
                  :items="localidades"
                  :rules="
                    servicio.tipoAsistenciaId == AJUSTE ||
                    servicio.tipoAsistenciaId == AUXILIO_VIAL
                      ? requiredRule
                      : []
                  "
                  item-text="localidad"
                  item-value="localidadId"
                  label="Localidad"
                  clearable
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row wrap justify="center">
              <v-col cols="5" class="py-0">
                <v-text-field
                  v-model="servicio.costo"
                  label="Costo ($)"
                  :rules="costoRule"
                  outlined
                  dense
                >
                  <template v-slot:prepend-inner>
                    <span style="padding-top: 5px">$</span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="7" class="pt-2">
                <v-switch
                  v-model="servicio.estado"
                  inset
                  class="pt-0 mt-0"
                  color="primary"
                  label="Estado de Servicio"
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4 pt-0 pb-4">
            <v-btn color="primary" outlined @click="limpiar">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="guardar">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- GUARDAR / EDITAR -->

    <v-row justify="space-between" align="center">
      <v-col cols="12">
        <h2 class="px-3">Detalles de Costos</h2>
      </v-col>
    </v-row>
    <v-stepper non-linear v-model="step">
      <v-stepper-header>
        <v-stepper-step editable step="1">Datos Generales</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step editable step="2"> Listado de Servicios</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-form ref="formCabecera" lazy-validation>
            <v-card>
              <v-card-title>
                <span class="text-h5">Datos Generales</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      label="Proveedor"
                      v-model="proveedor.nombre"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      label="Razón Social"
                      v-model="proveedor.razonSocial"
                      readonly
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      label="Tipo Proveedor"
                      v-model="proveedor.tipoProveedor"
                      readonly
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Fuera Turno (Local)"
                      :rules="numberRules"
                      v-model.number="cabecera.fueraTurno"
                      hint="Costo Local ($)"
                    >
                      <template v-slot:prepend-inner>
                        <span style="padding-top: 3px">$</span>
                      </template></v-text-field
                    >
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Fuera Turno (Foraneo)"
                      :rules="numberRules"
                      v-model.number="cabecera.fueraTurnoForaneo"
                      hint="Costo Foraneo ($)"
                    >
                      <template v-slot:prepend-inner>
                        <span style="padding-top: 3px">$</span>
                      </template></v-text-field
                    >
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Solo Vial"
                      :rules="numberRules"
                      v-model.number="cabecera.soloVial"
                      hint="Costo ($)"
                    >
                      <template v-slot:prepend-inner>
                        <span style="padding-top: 3px">$</span>
                      </template></v-text-field
                    >
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Auxilio Vial"
                      :rules="numberRules"
                      v-model.number="cabecera.auxilioVial"
                      hint="Costo ($)"
                    >
                      <template v-slot:prepend-inner>
                        <span style="padding-top: 3px">$</span>
                      </template></v-text-field
                    >
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Cartera Internacional"
                      :rules="numberRules"
                      v-model.number="cabecera.carteraInternacional"
                      hint="Costo ($)"
                    >
                      <template v-slot:prepend-inner>
                        <span style="padding-top: 3px">$</span>
                      </template></v-text-field
                    >
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="KM Adicional"
                      :rules="numberRules"
                      v-model.number="cabecera.kmAdicional"
                      hint="Costo por km ($)"
                    >
                      <template v-slot:prepend-inner>
                        <span style="padding-top: 3px">$</span>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Km Adicional Auxilio Vial"
                      :rules="numberRules"
                      v-model.number="cabecera.kmAuxilioVial"
                      hint="Costo por km ($)"
                    >
                      <template v-slot:prepend-inner>
                        <span style="padding-top: 3px">$</span>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Km Adicional Desde"
                      suffix="km"
                      :rules="numberRules"
                      v-model.number="cabecera.kmDesde"
                      hint="Adicional Desde"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="pt-0">
                    <v-textarea
                      v-model.trim="cabecera.observaciones"
                      label="Complemento"
                      counter
                      maxlength="1000"
                      no-resize
                      rows="5"
                      row-height="0"
                      outlined
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions class="pr-4 pt-0">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" dark @click="guardarCabecera">
                  {{
                    cabecera.costoProveedorId == null ? "Guardar" : "Actualizar"
                  }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-stepper-content>
      </v-stepper-items>
      <v-stepper-content step="2">
        <v-row align="center" justify="center" class="pt-4 pb-1">
          <v-col class="pt-0 pl-4" cols="12" md="4">
            <v-text-field
              class="text-xs-center"
              v-model="search"
              dense
              append-icon="search"
              label="Búsqueda"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <v-spacer></v-spacer>

          <v-col cols="12" md="2" class="text-right pt-0">
            <v-tooltip left color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  color="primary"
                  dark
                  :block="$vuetify.breakpoint.smAndDown"
                  @click="dialog = true"
                  :disabled="!cabecera.costoProveedorId"
                >
                  Agregar
                  <v-icon class="ml-1">fas fa-plus</v-icon>
                </v-btn>
              </template>
              <span>Agregar Nuevo Costo</span>
            </v-tooltip>
          </v-col>
        </v-row>

        <v-divider></v-divider>
        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="costosServicios"
              :items-per-page="5"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-container fluid class="px-4">
                  <h2 class="py-3 text-center">
                    Listado de Costos por Servicio
                  </h2>
                </v-container>
              </template>

              <template v-slot:[`item.opciones`]="{ item }">
                <v-btn icon @click="verDetalles(item)">
                  <v-icon>tab</v-icon>
                </v-btn>
              </template>

              <template v-slot:[`item.costo`]="{ item }">
                $ {{ item.costo.toFixed(2) }}
              </template>

              <template v-slot:[`item.estado`]="{ item }">
                <v-chip :color="item.estado ? 'green' : 'red'" dark>
                  {{ item.estado ? "Activo" : "Inactivo" }}
                </v-chip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-stepper-content>
    </v-stepper>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      AJUSTE: 1,
      AUXILIO_VIAL: 4,
      idProveedor: null,
      permisos: [],
      costosServicios: [],
      proveedor: {},
      cabecera: {
        costoProveedorId: null,
        fueraTurno: 0,
        fueraTurnoForaneo: 0,
        kmAdicional: 0,
        kmAuxilioVial: 0,
        kmDesde: 0,
        soloVial: 0,
        auxilioVial: 0,
        carteraInternacional: 0,
        observaciones: null,
      },
      servicio: {
        detalleCostoProveedorId: null,
        costoProveedorId: null,
        tipoAsistenciaId: null,
        tipoAsistencia: null,
        localidadId: null,
        localidad: null,
        costo: 0,
        estado: true,
      },
      tipoAsistencias: [],
      localidades: [],
      costoRule: [
        (v) => !!v || "Campo Requerido.",
        (v) => v > 0 || "Agregar Costo.",
        (v) =>
          /^(\d+(\.\d{1,2})?|(\.\d{1,2}))$/.test(v) ||
          "Solo se permiten números.",
      ],
      numberRules: [
        (v) =>
          /^(0(\.\d{1,2})?|[1-9]\d*(\.\d{1,2})?)$/.test(v) ||
          "Solo se permiten números.",
      ],

      requiredRule: [(v) => !!v || "Campo Requerido."],
      //asda
      step: 1,
      snack: false,
      snackColor: "primary",
      snackTime: 4000,
      snackText: "Notification",
      confirmDialog: false,
      confirmHeader: "Subir LLamadas",
      confirmText:
        "Esta accion sobreescribira la informacion actual de las LLamadas, Desea continuar?",
      isEdit: false,
      text: "Historial Gruas",
      search: "",
      dialog: false,
      headers: [
        {
          text: "TipoAsistencia",
          value: "tipoAsistencia",
          align: "center",
          width: 200,
        },
        {
          text: "Localidad",
          value: "localidad",
          width: 150,
          align: "center",
        },
        {
          text: "Costo",
          value: "costo",
          width: 100,
          align: "center",
        },
        {
          text: "Estado",
          value: "estado",
          width: 100,
          align: "center",
        },
        {
          text: "Opciones",
          value: "opciones",
          width: 100,
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  async created() {
    if (!this.$store.state.usuario) {
      this.$router.push({ name: "login" });
    } else {
      await this.listarPermisos();

      if (!this.permisoModulo()) {
        this.$router.push({ name: "novedades" });
      } else {
        this.listarComboBox();
        this.idProveedor = this.$route.params.id;

        if (this.idProveedor) {
          let header = { Authorization: "Bearer " + this.$store.state.token };
          let configuracion = { headers: header };

          axios
            .get(
              `api/CostosProveedores/${this.idProveedor}/Proveedor`,
              configuracion
            )
            .then((res) => {
              if (res.status == 200) {
                this.cabecera = res.data;
              }
              this.getProveedorInfo();
            })
            .catch((err) => console.error(err.data));
        }
      }
    }
  },
  watch: {
    cabecera(val) {
      if (val.costoProveedorId) {
        this.getDetallesCostosProveedor(val.costoProveedorId);
      }
    },
    "servicio.tipoAsistenciaId"(val) {
      if (val != this.AJUSTE && val != this.AUXILIO_VIAL) {
        this.servicio.localidadId = null;
        this.servicio.localidad = null;
      }
    },
  },
  computed: {
    getDialogTitle() {
      return this.servicio.costoProveedorId == null ? "Agregar" : "Editar";
    },
  },
  methods: {
    async listarPermisos() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      await axios
        .get(
          "api/Permisos/Listar/" + this.$store.state.usuario.idRol,
          configuracion
        )
        .then((response) => {
          this.permisos = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    permisoModulo() {
      var index = this.permisos.findIndex((object) => {
        return object.nombre_modulo == "Proveedores";
      });
      if (index != -1) {
        return true;
      }
    },
    verDetalles(item) {
      this.dialog = true;
      this.isEdit = true;
      this.servicio = { ...item };

      this.servicio.localidadId = item.localidadId;
      this.servicio.localidad = item.localidad;
    },
    getDetallesCostosProveedor(costoProveedorId) {
      if (!costoProveedorId) return;

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `api/DetalleCostoProveedor/${costoProveedorId}/Detalle`,
          configuracion
        )
        .then((res) => {
          this.costosServicios = res.data;
        })
        .catch((err) => console.error(err));
    },
    guardarCabecera() {
      if (this.proveedor.idProveedor && this.$refs.formCabecera.validate()) {
        if (
          this.cabecera.costoProveedorId &&
          this.$refs.formCabecera.validate()
        ) {
          let header = { Authorization: "Bearer " + this.$store.state.token };
          let configuracion = { headers: header };

          axios
            .put(
              `api/CostosProveedores/${this.cabecera.costoProveedorId}`,
              {
                proveedorId: this.idProveedor,
                kmAdicional: this.cabecera.kmAdicional,
                kmDesde: this.cabecera.kmDesde,
                kmAuxilioVial: this.cabecera.kmAuxilioVial,
                fueraTurno: this.cabecera.fueraTurno,
                fueraTurnoForaneo: this.cabecera.fueraTurnoForaneo,
                soloVial: this.cabecera.soloVial,
                auxilioVial: this.cabecera.auxilioVial,
                carteraInternacional: this.cabecera.carteraInternacional,
                observaciones: this.cabecera.observaciones,
              },
              configuracion
            )
            .then((res) => {
              this.snackColor = "primary";
              this.snackText = "Datos Actualizados Correctamente!";
              this.snack = true;
            })
            .catch((err) => {
              this.snackColor = "error";
              this.snackText = "No se pudo actualizar.";
              this.snack = true;
              console.error(err.data);
            });
        } else {
          let header = { Authorization: "Bearer " + this.$store.state.token };
          let configuracion = { headers: header };

          axios
            .post(
              "api/CostosProveedores",
              {
                proveedorId: this.idProveedor,
                kmAdicional: this.cabecera.kmAdicional,
                kmAuxilioVial: this.cabecera.kmAuxilioVial,
                kmDesde: this.cabecera.kmDesde,
                fueraTurno: this.cabecera.fueraTurno,
                fueraTurnoForaneo: this.cabecera.fueraTurnoForaneo,
                soloVial: this.cabecera.soloVial,
                auxilioVial: this.cabecera.auxilioVial,
                carteraInternacional: this.cabecera.carteraInternacional,
                observaciones: this.cabecera.observaciones,
              },
              configuracion
            )
            .then((res) => {
              this.cabecera.costoProveedorId = res.data;

              this.snackColor = "primary";
              this.snackText = "Datos Guardados Correctamente!";
              this.snack = true;
            })
            .catch((err) => {
              console.error(err.data);
              this.snackColor = "error";
              this.snackText = "No se pudo guardar.";
              this.snack = true;
            });
        }
      } else {
        this.snackColor = "error";
        this.snackText = "Por favor, verifica los datos ingresados.";
        this.snack = true;
      }
    },
    guardarServicio() {
      const body = {
        costoProveedorId: this.cabecera.costoProveedorId,
        tipoAsistenciaId: this.servicio.tipoAsistenciaId,
        localidadId: this.servicio.localidadId,
        costo: this.servicio.costo,
        estado: this.servicio.estado,
      };

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .post("api/DetalleCostoProveedor", body, configuracion)
        .then((res) => {
          if (res.status == 200) {
            this.getDetallesCostosProveedor(this.cabecera.costoProveedorId);
            this.limpiar();
          }
        })
        .catch((err) => console.error(err.data));
    },
    updateServicio() {
      const body = {
        costoProveedorId: this.cabecera.costoProveedorId,
        tipoAsistenciaId: this.servicio.tipoAsistenciaId,
        localidadId: this.servicio.localidadId,
        costo: this.servicio.costo,
        estado: this.servicio.estado,
      };

      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .put(
          `api/DetalleCostoProveedor/${this.servicio.detalleCostoProveedorId}`,
          body,
          configuracion
        )
        .then((res) => {
          if (res.status == 200) {
            this.getDetallesCostosProveedor(this.cabecera.costoProveedorId);
            this.limpiar();
          }
        })
        .catch((err) => console.error(err.data));
    },
    listarComboBox() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/TipoAsistencias/Activas", configuracion)
        .then((res) => {
          this.tipoAsistencias = res.data;
        })
        .catch((err) => console.error(err.data));

      axios
        .get("api/CostosProveedores/Localidades", configuracion)
        .then((res) => {
          this.localidades = res.data;
        })
        .catch((err) => console.error(err.data));
    },
    getProveedorInfo() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `api/DetallexProveedores/ListarId/${this.idProveedor}`,
          configuracion
        )
        .then((res) => {
          this.proveedor = res.data[0];
        })
        .catch((err) => console.error(err.data));
    },
    limpiar() {
      if (this.$refs.form.resetValidation()) {
        this.$refs.form.resetValidation();
      }
      this.confirmDialog = false;
      this.dialog = false;
      this.isEdit = false;

      this.servicio = {
        detalleCostoProveedorId: null,
        costoProveedorId: null,
        tipoAsistenciaId: null,
        tipoAsistencia: null,
        localidadId: null,
        localidad: null,
        costo: 0,
        estado: true,
      };
    },
    guardar() {
      if (this.$refs.form.validate()) {
        if (this.isEdit) {
          this.updateServicio();
        } else {
          this.guardarServicio();
        }
      }
    },
  },
};
</script>